import { render, staticRenderFns } from "./OsdiButton.vue?vue&type=template&id=3fff62f0&scoped=true&"
import script from "./OsdiButton.vue?vue&type=script&lang=ts&"
export * from "./OsdiButton.vue?vue&type=script&lang=ts&"
import style0 from "./OsdiButton.vue?vue&type=style&index=0&id=3fff62f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fff62f0",
  null
  
)

export default component.exports